<template>
  <div class="side-menu-container f fv">
    <div class="top-info f fv fvc">
      <div class="f fv fvc fbt">
        <div @click="openStatusDialog">
          <div class="avatar f fvc" :style="{ backgroundColor: currentUserInfo?.avatar_color || '' }">
            <span class="name">{{ calcUserName }}</span>
          </div>
          <div class="status f fvc">
            <div class="circle" :style="{ backgroundColor: statusMap[currentStatusIndex]?.color || '' }"></div>
          </div>
        </div>
      </div>
      <div class="status-txt">{{ statusMap[currentStatusIndex]?.name || '' }}</div>
    </div>

    <!-- 状态选择弹窗 -->
    <el-dialog
      v-model="visible"
      title="选择自己的工作状态"
      width="700px"
      :close-on-click-modal="false"
      :show-close="true"
      append-to-body
    >
      <div class="status-dialog-content">
        <div class="status-cards">
          <div
            v-for="item in statusMap"
            :key="item.value"
            :class="['status-card', { active: currentStatus === item.value }]"
            @click="setCurrentStatus(item.value)"
          >
            <div>
              <CheckCircleFilled v-if="item.value === 1" style="color: #8cd573; font-size: 24px" />
              <PauseCircleFilled v-else-if="item.value === 2" style="color: #e6ad64; font-size: 24px" />
              <MinusCircleFilled v-else style="color: #a2a9b6; font-size: 24px" />
            </div>
            <div class="status-name">{{ item.name }}</div>
            <div v-if="currentStatus === item.value" class="status-check">
              <CheckOutlined style="color: #fff; font-size: 16px" />
            </div>
          </div>
        </div>
        <div class="status-descriptions">
          <div class="description-item" v-for="item in statusMap" :key="item.value">
            <span class="description-label">{{ item.textLabel }}</span>
            <span>{{ item.textValue }}</span>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="visible = false">取消</el-button>
          <el-button type="primary" @click="changeStatus">確定</el-button>
        </div>
      </template>
    </el-dialog>

    <div class="detail-box f fv fbt">
      <div class="menu-list f fv fc">
        <div
          v-for="item in calcUserMenu"
          :class="`${currentPath?.startsWith(item.path) ? 'current-item' : ''} menu-item`"
          :key="item.id"
          :id="item.id"
          :alt="item.name"
          @click="jump(item.path)"
          @mouseover="handlerMouseAction(item.id)"
          @mouseleave="handlerMouseAction('')"
        >
          <!-- <div class="tip"></div> -->
          <div class="f fv fvc menu-item-chat">
            <el-image
              :src="item.iconImgActived"
              v-show="currentPath?.startsWith(item.path) || item.id == currentHoverPath"
            />
            <el-image :src="item.iconImg" v-show="!currentPath?.startsWith(item.path) && item.id != currentHoverPath" />
            <p class="name">{{ item.name }}</p>
            <span class="unread-number" v-if="calcUnreadNumber && item.id === 'chat'">{{
              calcUnreadNumber > 99 ? '99+' : calcUnreadNumber
            }}</span>
          </div>
        </div>
      </div>
      <div class="bottom-area f fc fv">
        <!-- <div class="pointer mb20" @click="openManual">
          <div class="fvc">
            <ReadOutlined style="color: #3a84f1" />
          </div>
          <el-button link type="primary" size="small">操作指南</el-button>
        </div> -->
        <el-popover placement="right-start" :width="225" trigger="hover" v-if="!isSingapore">
          <template #reference>
            <div class="more">手機端</div>
          </template>
          <img
            src="https://fe-img.tengzhihh.com/image/755b463f82245c9592f898ac1dd465ea-258x258.jpeg"
            style="width: 200px; height: auto"
          />
          <div class="more-tip" style="text-align: center">关注服務号，回復“服務中心”</div>
        </el-popover>
        <el-popover placement="right-start" trigger="hover">
          <template #reference>
            <div class="team-name clamp1">{{ calcTeamName }}</div>
          </template>
          <div>{{ calcTeamName }}</div>
        </el-popover>
        <!-- <el-tooltip
          effect="light"
          content="超時未處理"
          placement="top"
          :visible="timeoutVisible"
          v-if="!isWechatBrowser"
        >
          <div :class="`ring-box ${timeoutVisible ? 'ring-ani' : ''}`">
            <div class="number" v-if="calcUnreadNumber">{{ calcUnreadNumber }}</div>
            <bell-outlined class="ring" />
          </div>
        </el-tooltip> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Cookies from 'js-cookie';
import bus from '@/lib/bus';
import { storeToRefs } from 'pinia';
import { rootStore } from '@/store/rootStore';
import { menuListStore } from '@/store/menuListStore';
import { chatStore } from '@/store/chatStore';
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import request from '@/lib/request';
import apiPath from '@/lib/apiPath';
import { ElMessage } from 'element-plus';
import { isSingapore } from '@/lib/const';
import { CheckCircleFilled, PauseCircleFilled, MinusCircleFilled, CheckOutlined } from '@ant-design/icons-vue';

const statusMap = [
  {
    name: '在線',
    color: '#00df92',
    value: 1,
    textLabel: '我要在線：',
    textValue: '進入客户分配模式;',
  },
  {
    name: '忙碌',
    color: 'orange',
    value: 2,
    textLabel: '我在忙碌：',
    textValue: '不再主動給你分配客户, 其他客服也無法給你轉接, 可以正常接待我的客户;',
  },
  {
    name: '離線',
    color: 'gray',
    value: 0,
    textLabel: '我要離線：',
    textValue: '不再給你分配客户, 其他客服也不能給你轉接;',
  },
];
const rootStoreEx = rootStore();
const menuListStoreEx = menuListStore();
const chatStoreEx = chatStore();
const { currentUserInfo, currentCSInfo, userMenu } = storeToRefs(rootStoreEx);
const { menuList, currentPath } = storeToRefs(menuListStoreEx);
const { currentChatList } = storeToRefs(chatStoreEx);
const calcInternal = computed(() => currentCSInfo.value?.type == 1);
const calcUserName = computed(() =>
  calcInternal.value
    ? currentUserInfo.value?.name?.split('-')[1]?.slice(0, 2) || currentUserInfo.value?.name?.slice(0, 2)
    : currentUserInfo.value?.name?.slice(0, 2)
);
const calcTeamName = computed(() => currentUserInfo.value?.teamName);
const router = useRouter();
const jump = (path: string) => {
  if (currentPath.value?.startsWith(path)) return;
  router.push(path);
};
const currentStatusIndex = computed(() => {
  return statusMap.findIndex((item) => item.value === currentCSInfo.value?.state);
});
const calcUserMenu = computed(() => {
  const arr =
    menuList.value?.filter((i) => {
      return userMenu.value?.map((j) => j.uri).includes(i.id) || i.module_id === -1;
    }) || [];
  return currentUserInfo.value?.teamId ? arr : arr.filter((v) => v.id == 'setting');
});
const currentHoverPath = ref('');
const handlerMouseAction = (path: string) => {
  if (path !== currentHoverPath.value) {
    currentHoverPath.value = path;
  }
};
const getUserState = () => {
  if (Cookies.get('IM-Token')) {
    request.get(apiPath.user.getState).then((res) => {
      rootStoreEx.setCSInfo(res);
      currentStatus.value = res?.state;
    });
  }
};
const currentStatus = ref(0);
const changeStatus = () => {
  if (!currentUserInfo.value?.teamId) {
    return ElMessage.warning('未配置團隊，請先加入團隊');
  }
  request
    .post(apiPath.user.changeState, {
      state: currentStatus.value,
    })
    .then(() => {
      rootStoreEx.changeCSCurrentStatus(currentStatus.value);
      visible.value = false;
    });
};
const setCurrentStatus = (v) => {
  currentStatus.value = v;
};
const openStatusDialog = () => {
  currentStatus.value = currentCSInfo.value?.state ?? 0;
  visible.value = true;
};
const visible = ref(false);
const timeoutVisible = ref(false);
const calcUnreadNumber = computed(() => {
  const msg = currentChatList.value?.personal?.msgItems || [];
  let total = msg.reduce((acc, cur) => {
    return acc + cur?.unread_num || 0;
  }, 0);

  if (total > 0) {
    document.title = `未讀訊息[${total}] - ${import.meta.env.VITE_PROJECT_NAME}`;
    carouselTitleTimer.value || carouselTitle();
  } else {
    carouselTitleTimer.value && window.clearInterval(carouselTitleTimer.value);
    document.title = import.meta.env.VITE_PROJECT_NAME;
  }
  setDocumentIcon(total);
  return total;
});
const carouselTitleTimer = ref();
const carouselTitle = () => {
  carouselTitleTimer.value = setInterval(() => {
    let keyList = document.title?.split('') || [];
    let firstStr = keyList.shift() || '';
    keyList.push(firstStr);
    document.title = keyList.join('');
  }, 300);
};
let messageIconFlag = false;
const setDocumentIcon = (total = 0) => {
  if (total && messageIconFlag) return;
  const link = document.querySelector("link[rel*='icon']");
  if (link) {
    link.type = total ? 'image/png' : 'image/icon';
    link.rel = 'icon';
    link.href = total ? '/message.png' : import.meta.env.VITE_FAVICON;
    document.getElementsByTagName('head')[0]?.removeChild(link);
    document.getElementsByTagName('head')[0]?.appendChild(link);
    messageIconFlag = total > 0;
  }
};
const openManual = () => {
  window.open('https://alidocs.dingtalk.com/i/nodes/G1DKw2zgV2y3ezjxSMwQ0LBPWB5r9YAn?utm_scene=team_space');
};
const listener = (e, v) => {
  if (e === 'msgTimeoutOpen') {
    timeoutVisible.value = true;
  } else if (e === 'msgTimeoutClose') {
    timeoutVisible.value = false;
  } else if (e === 'refreshUserCsInfoState') {
    getUserState();
  }
};
const initBus = () => {
  bus.on(listener);
};
onMounted(() => {
  getUserState();
  initBus();
});
onUnmounted(() => {
  bus.off(listener);
});
</script>
<style lang="less" scoped>
.side-menu-container {
  padding-bottom: 10px;
  color: #fff;
  height: 100vh;
  .top-info {
    position: relative;
    margin: 16px 0 18px;
    .avatar {
      width: 42px;
      height: 42px;
      border-radius: 50%;
      cursor: pointer;
    }
    .name {
      font-size: 12px;
    }
    .status {
      position: absolute;
      right: 17px;
      top: 28px;
      padding: 3px;
      background-color: #304a65;
      border-radius: 50%;
      cursor: pointer;
      font-size: 12px;
      .circle {
        width: 11px;
        height: 11px;
        border-radius: 50%;
      }
    }
    .status-txt {
      margin-top: 6px;
      font-size: 12px;
    }
  }
  .detail-box {
    flex: 1;
  }
  .menu-list {
    font-size: 24px;
    z-index: 10000;
    .menu-item {
      cursor: pointer;
      margin-bottom: 6px;

      position: relative;
      width: 85%;
      padding: 6px 3px;
      .tip {
        width: 10px;
        height: 10px;
        background-color: #fd3e43;
        border-radius: 50%;
        position: absolute;
        top: 6px;
        right: -4px;
      }
      .name {
        margin-top: 8px;
        letter-spacing: 1px;
      }
      .menu-item-chat {
        position: relative;
        font-size: 12px;
        .el-image {
          width: 20px;
        }
        .unread-number {
          background-color: red;
          color: white;
          font-size: 12px;
          border-radius: 10px;
          position: absolute;
          top: -2px;
          right: 10px;
          line-height: 16px;
          height: 16px;
          min-width: 16px;
          text-align: center;
          // font-weight: 600;
        }
      }
      .iconfont {
        font-size: 20px;
      }
    }
    .current-item {
      background-color: #243349;
      color: #4599e3;
      border-radius: 10px;
      .name {
        font-size: 12px;
        color: #4599e3;
      }
    }
    .name {
      font-size: 12px;
      color: #fff;
      margin-top: 4px;
    }
    .menu-item:hover {
      background-color: #243349;
      border-radius: 10px;
      color: #4599e3;
      .name {
        color: #4599e3;
      }
    }
  }

  .bottom-area {
    .more {
      height: 18px;
      text-align: right;
      font-size: 14px;
      line-height: 0px;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .more-tip {
      padding: 15px 25px;
      font-size: 12px;
      text-align: center;
    }

    .ring-box {
      position: relative;
      .number {
        font-size: 12px;
        position: absolute;
        top: 4px;
        right: 5px;
        width: 20px;
        line-height: 20px;
        text-align: center;
        color: #2d2d2d;
      }
      .ring {
        font-size: 28px;
        margin-bottom: 20px;
        color: #2d2d2d;
      }
    }
    .mb20 {
      margin-bottom: 20px;
    }
    .team-name {
      font-size: 12px;
    }
  }
}

.status-dialog-content {
  padding: 20px;

  .status-cards {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;

    .status-card {
      flex: 1;
      position: relative;
      cursor: pointer;
      transition: all 0.3s;
      background-color: #fff;
      box-shadow: transparent 0 0 0 0, rgba(162, 169, 182, 0.5) 0 0 3px 1px;
      height: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &:hover {
        box-shadow: transparent 0 0 0 0, rgba(85, 118, 216, 1) 0 0 3px 1px;
        background-color: #f0f7ff;
      }

      &.active {
        background-color: #f0f7ff;
        box-shadow: transparent 0 0 0 0, rgba(85, 118, 216, 1) 0 0 3px 1px;
      }

      .status-name {
        margin: 12px auto 0;
        text-align: center;
        font-size: 14px;
        color: #666;
        font-weight: 600;
      }

      .status-check {
        position: absolute;
        top: 0;
        right: 0;
        width: 40px;
        height: 40px;
        background-color: #5576d8;
        clip-path: polygon(0 0, 100% 0, 100% 100%);
        text-align: right;
        padding: 4px 4px 0 0;
      }
    }
  }

  .status-descriptions {
    padding: 16px;
    background-color: #f9fbff;
    min-height: 60px;
    border: 1px solid #c9d6f3;

    .description-item {
      font-size: 14px;
      line-height: 2.5;
      color: #555;

      .description-label {
        font-weight: 500;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
